import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ArrowLeft, Plus } from "lucide-react";
import { listMatrixData, createSubstance } from "@/lib/admin-matrix.functions";

export const Route = createFileRoute("/_authenticated/_admin/admin/substances/new")({
  component: NewSubstancePage,
});

const input: React.CSSProperties = {
  width: "100%", background: "rgba(255,255,255,0.04)",
  border: "1px solid var(--border-purple)", borderRadius: 6,
  padding: "0.45rem 0.6rem", color: "var(--text-primary)", fontSize: "0.9rem",
};
const label: React.CSSProperties = {
  display: "block", color: "var(--text-secondary)", fontSize: "0.78rem",
  textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4,
};

function NewSubstancePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const fetchData = useServerFn(listMatrixData);
  const doCreate = useServerFn(createSubstance);
  const { data } = useQuery({ queryKey: ["admin-matrix-data"], queryFn: () => fetchData() });

  const [name, setName] = useState("");
  const [cat, setCat] = useState("");
  const [sort, setSort] = useState(0);
  const [saving, setSaving] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const row = await doCreate({ data: { name: name.trim(), category_id: cat ? Number(cat) : null, sort_order: sort } });
      toast.success("Substanz angelegt");
      queryClient.invalidateQueries({ queryKey: ["admin-substances", "list"] });
      navigate({ to: "/admin/substances/$id/edit", params: { id: (row as any).id } });
    } catch (e: any) {
      toast.error("Fehler", { description: e?.message ?? String(e) });
    } finally { setSaving(false); }
  }

  return (
    <div style={{ maxWidth: 640, margin: "2rem auto", padding: "0 1.5rem" }}>
      <Link to="/admin" style={{ color: "var(--accent-cyan)", textDecoration: "none", fontSize: "0.85rem", display: "inline-flex", alignItems: "center", gap: 4 }}>
        <ArrowLeft size={14} /> Zurueck
      </Link>
      <h1 style={{ color: "var(--accent-cyan)" }}>Neue Substanz</h1>
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem", background: "var(--bg-surface)", border: "1px solid var(--border-purple)", borderRadius: 8, padding: "1.25rem" }}>
        <div>
          <label style={label}>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} style={input} required />
        </div>
        <div>
          <label style={label}>Kategorie</label>
          <select value={cat} onChange={(e) => setCat(e.target.value)} style={input}>
            <option value="">Keine</option>
            {(data?.categories ?? []).map((c: any) => (
              <option key={c.id} value={c.id}>{c.label_de ?? c.key}</option>
            ))}
          </select>
        </div>
        <div>
          <label style={label}>Sortierung</label>
          <input type="number" value={sort} onChange={(e) => setSort(Number(e.target.value))} style={input} />
        </div>
        <button type="submit" disabled={saving} style={{ padding: "0.55rem 1.1rem", background: "var(--accent-cyan)", color: "#0f0a1a", border: "none", borderRadius: 6, fontWeight: 600, cursor: saving ? "wait" : "pointer", alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: 6 }}>
          <Plus size={14} /> {saving ? "Speichere…" : "Anlegen"}
        </button>
      </form>
    </div>
  );
}
